module.exports = __webpack_public_path__ + "sit/20260421123616/img/service.edbff227.png";